import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import AppLayout from "./components/Layout/AppLayout";
import Login from "./components/Auth/Login";
import Signup from "./components/Auth/Signup";
import VerifyOtp from "./components/Auth/VerifyOtp";
import ForgotPassword from "./components/Auth/ForgotPassword";
import CompanySetup from "./components/Auth/CompanySetup";

import Dashboard from "./components/Dashboard/Dashboard";
import LocationsList from "./components/Locations/LocationsList";
import LocationForm from "./components/Locations/LocationForm";
import LocationDetail from "./components/Locations/LocationDetail";
import NewBidRequest from "./components/Bids/NewBidRequest";
import BidsHub from "./components/Bids/BidsHub";
import Controls from "./components/Controls/Controls";
import OrdersList from "./components/Orders/OrdersList";
import OrderDetail from "./components/Orders/OrderDetail";
import ClosedMarket from "./components/ClosedMarket/ClosedMarket";
import ClosedMarketOrderDetail from "./components/ClosedMarket/ClosedMarketOrderDetail";
import Funds from "./components/Funds/Funds";
import MarketUpdates from "./components/MarketUpdates/MarketUpdates";
import Notifications from "./components/Notifications/Notifications";
import Help from "./components/Help/Help";
import Settings from "./components/Settings/Settings";
import CompanyVerification from "./components/Company/CompanyVerification";
import Messages from "./components/Messages/Messages";
import LegalPage from "./components/Legal/LegalPage";

function ProtectedRoute({ children }) {
	const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);
	if (!isAuthenticated) return <Navigate to="/login" replace />;
	return children;
}

function PublicOnlyRoute({ children }) {
	const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);
	if (isAuthenticated) return <Navigate to="/" replace />;
	return children;
}

export default function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/login" element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
				<Route path="/signup" element={<PublicOnlyRoute><Signup /></PublicOnlyRoute>} />
				<Route path="/verify-otp" element={<VerifyOtp />} />
				<Route
					path="/company-setup"
					element={
						<ProtectedRoute>
							<CompanySetup />
						</ProtectedRoute>
					}
				/>
				<Route path="/forgot-password" element={<PublicOnlyRoute><ForgotPassword /></PublicOnlyRoute>} />

				<Route
					path="/"
					element={
						<ProtectedRoute>
							<AppLayout />
						</ProtectedRoute>
					}
				>
					<Route index element={<Dashboard />} />
					<Route path="locations" element={<LocationsList />} />
					<Route path="locations/new" element={<LocationForm />} />
					<Route path="locations/:locationId/edit" element={<LocationForm />} />
					<Route path="locations/:locationId" element={<LocationDetail />} />
					<Route path="bids" element={<BidsHub />} />
					<Route path="bids/new" element={<NewBidRequest />} />
					<Route path="controls" element={<Controls />} />
					<Route path="orders" element={<OrdersList />} />
					<Route path="orders/:orderId" element={<OrderDetail />} />
					<Route path="closed-market" element={<ClosedMarket />} />
					<Route path="closed-market/:orderId" element={<ClosedMarketOrderDetail />} />
					<Route path="funds" element={<Funds />} />
					<Route path="market-updates" element={<MarketUpdates />} />
					<Route path="notifications" element={<Notifications />} />
					<Route path="help" element={<Help />} />
					<Route path="settings" element={<Settings />} />
					<Route path="company-verification" element={<CompanyVerification />} />
					<Route path="messages" element={<Messages />} />
					<Route path="terms-of-service" element={<LegalPage />} />
					<Route path="privacy-policy" element={<LegalPage />} />
				</Route>

				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>
		</BrowserRouter>
	);
}
